import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax

// mapbox のスタイルを使わなければトークンは不要。
mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_ACCESSTOKEN;

const STYLES = {
    'mapbox-hazard-map': process.env.REACT_APP_MAPBOX_STYLE,

    // 国土地理院 標準
    'gsi-std': {
        version: 8,
        sources: {
            'gsi-std': {
                type: "raster",
                tiles: ["https://cyberjapandata.gsi.go.jp/xyz/std/{z}/{x}/{y}.png"],
                tileSize: 256,
                attribution:
                    '<a href="https://maps.gsi.go.jp/development/ichiran.html" target="_blank">地理院タイル</a>',
            }
        },
        layers: [{
            id: "gsi-std",
            type: "raster",
            source: "gsi-std",
            minzoom: 0,
            maxzoom: 18
        }]
    },

    // 国土地理院 淡色
    'gsi-pale': {
        version: 8,
        sources: {
            'gsi-pale': {
                type: "raster",
                tiles: ["https://cyberjapandata.gsi.go.jp/xyz/pale/{z}/{x}/{y}.png"],
                tileSize: 256,
                attribution:
                    '<a href="https://maps.gsi.go.jp/development/ichiran.html" target="_blank">地理院タイル</a>',
            }
        },
        layers: [{
            id: "gsi-pale",
            type: "raster",
            source: "gsi-pale",
            minzoom: 0,
            maxzoom: 18
        }]
    },
}


// mapbox をラップしたクラス
export default class MapBoxEx {
    constructor(mapContainerRef, lng, lat, zoom) {
        this._mapbox = new mapboxgl.Map({
            container: mapContainerRef.current,
            style: STYLES['mapbox-hazard-map'],
            center: [lng, lat],
            zoom: zoom,
            hash: true,
            preserveDrawingBuffer: true,
        });

        this._popup = new mapboxgl.Popup({
            closeButton: false,
            closeOnClick: false
        })

        this._layers = [];  // ハザードマップ単位、気象要素単位のレイヤー。複数の mapbox レイヤーから構成される。
    }

    get mapbox() { return this._mapbox; }

    async add(layer) {
        this._layers.push(layer);
        layer.map = this._mapbox
        return layer.add();
    }

    remove(layer) {
        this._layers = this._layers.filter(x => (x !== layer));
        layer.remove();
    }

    isExist(layer) {
        return this._layers.includes(layer);
    }

    initHandlers() {
        // 見えてる mapbox レイヤーにカーソルがあれば十字に変える。
        this._mapbox.on('mousemove', (e) => {
            // 各レイヤーを構成する mapbox レイヤーを集計する。
            const layers = [];
            this._layers.forEach(layer => layers.push(...Object.keys(layer.layers)));

            const visibleLayers = layers.filter(x =>
                (this._mapbox.getLayer(x) && this._mapbox.getLayoutProperty(x, 'visibility') === 'visible')
            );

            if (visibleLayers.length === 0) {
                return;
            }

            const features = this._mapbox.queryRenderedFeatures(e.point, { layers: visibleLayers });
            this._mapbox.getCanvas().style.cursor = (features.length) ? 'crosshair' : '';
        });

        this._mapbox.on('click', (e) => {
            this._popup.remove();

            const contents = [];
            this._layers.forEach(x => {
                const content = x.onClick(e);
                if (content != null) {
                    contents.push(content);
                }
            })

            if (0 < contents.length) {
                this._popup.setLngLat(e.lngLat)
                    .setHTML(contents.join(''))
                    .addTo(this._mapbox);
            }
        });
    }

    popup(lngLat, content) {
        this._popup.setLngLat(lngLat)
            .setHTML(content)
            .addTo(this._mapbox);
    }

    loadImage(props) {
        return new Promise((resolve, reject) => {
            this._mapbox.loadImage(props.url, (err, image) => {
                if (err) {
                    reject(err);
                }

                this._mapbox.addImage(props.name, image, props.options);
                resolve();
            });
        });
    }

    createMarker(options) {
        return new mapboxgl.Marker(options)
            .setLngLat([0, 0])
            .addTo(this._mapbox);
    }

    updateLayerOrder(order) {
        // 最前面から再後面まで move する。

        // マップボックスのラベル系レイヤー。配列順に最前面→再後面
        const mapboxLayers = [
            // 'country-label',
            // 'state-label',
            // 'settlement-major-label',
            // 'settlement-minor-label',
            // 'settlement-subdivision-label',
            // 'airport-label',
            // 'poi-label',
            // 'water-point-label',
            // 'water-line-label',
            // 'natural-point-label',
            // 'natural-line-label',
            // 'waterway-label',

            // // 'building-extrusion',
            // 'building-outline',

            // 'bridge-simple',
            // 'bridge-case-simple',
            // 'road-simple',
            // 'tunnel-simple',

            // // 'road-intersection',
            // // 'road-label',
            // // 'block-number-label',
            // // 'building-number-label',

            // // 'tunnel-street-minor-low',
            // // 'tunnel-street-minor-case',
            // // 'tunnel-primary-secondary-tertiary-case',
            // // 'tunnel-major-link-case',
            // // 'tunnel-motorway-trunk-case',
            // // 'tunnel-construction',
            // // 'tunnel-major-link',
            // // 'tunnel-street-minor',
            // // 'tunnel-primary-secondary-tertiary',
            // // 'tunnel-motorway-trunk',
            // // 'turning-feature-outline',
            // // 'road-minor-low',
            // // 'road-minor-case',
            // // 'road-street-low',
            // // 'road-street-case',
            // // 'road-secondary-tertiary-case',
            // // 'road-primary-case',
            // // 'road-major-link-case',
            // // 'road-motorway-trunk-case',
            // // 'road-construction',
            // // 'road-major-link',
            // // 'road-minor',
            // // 'road-street',
            // // 'road-secondary-tertiary',
            // // 'road-primary',
            // // 'road-motorway-trunk',
            // // 'turning-feature',
            // // 'bridge-street-minor-low',
            // // 'bridge-street-minor-case',
            // // 'bridge-primary-secondary-tertiary-case',
            // // 'bridge-major-link-case',
            // // 'bridge-motorway-trunk-case',
            // // 'bridge-construction',
            // // 'bridge-major-link',
            // // 'bridge-street-minor',
            // // 'bridge-primary-secondary-tertiary',
            // // 'bridge-motorway-trunk',
            // // 'bridge-major-link-2-case',
            // // 'bridge-motorway-trunk-2-case',
            // // 'bridge-major-link-2',
            // // 'bridge-motorway-trunk-2',

            // 'bridge-rail',
            // 'road-rail',
            // 'aeroway-line',
            // 'aeroway-polygon',
        ]

        let upper = null;

        mapboxLayers.forEach(id => {
            if (upper === null) {
                this._mapbox.moveLayer(id); // 最前面
            } else {
                this._mapbox.moveLayer(id, upper); // id が背面。
            }
            upper = id;
        })

        order.forEach(id => {
            if (upper === null) {
                this._mapbox.moveLayer(id); // 最前面
            } else {
                this._mapbox.moveLayer(id, upper); // id が背面。
            }
            upper = id;
        })
    }
};